import React from "react";
import AnimatedPage from "../AnimatedPage";

const TanEntreprises = () => {
  return (
    <AnimatedPage>
      <div className="iframe__ctn">
        <iframe title="Site Naolib Pro" src="https://pro.naolib.fr/"></iframe>
      </div>
    </AnimatedPage>
  );
};

export default TanEntreprises;
